module.exports = __webpack_public_path__ + "static_portal/img/video_with_angles.2bd904a3.jpg";